// src/Components/AdminLogin.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ADMIN_PASSWORD =
  process.env.REACT_APP_ADMIN_PASSWORD || "change-this-password";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (password === ADMIN_PASSWORD) {
      // Mark admin as authenticated
      localStorage.setItem("navveer_admin_auth", "true");
      navigate("/admin", { replace: true });
    } else {
      setError("Incorrect password. Please try again.");
    }
  };

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 380,
          border: "1px solid #ddd",
          borderRadius: 10,
          padding: 20,
          backgroundColor: "#fff",
          boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 12, textAlign: "center" }}>
          Admin Login
        </h2>
        <p style={{ fontSize: 13, color: "#666", textAlign: "center" }}>
          Enter the admin password to access the dashboard.
        </p>

        <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
          <label style={{ display: "block", marginBottom: 8 }}>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: 8,
                marginTop: 4,
                borderRadius: 6,
                border: "1px solid #ccc",
              }}
            />
          </label>

          {error && (
            <p style={{ color: "red", fontSize: 13, marginTop: 8 }}>{error}</p>
          )}

          <button
            type="submit"
            style={{
              width: "100%",
              marginTop: 12,
              padding: "8px 0",
              borderRadius: 6,
              border: "none",
              backgroundColor: "#007bff",
              color: "#fff",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
